import { ContainerProps, Box } from '@chakra-ui/react';

const Banner = ({ children }: ContainerProps) => {
  return (
    <Box
      bgColor={'#1E2021'}
      border={'1px solid'}
      borderColor={'#323537'}
      dropShadow={'initial'}
      width={'100%'}
    >
      {children}
    </Box>
  );
};

export default Banner;
